export default {
  leave: {
    crud: {
      create: "İzin Talebi Oluştur"
    },
    menu: {
      leave_accruals: "İzin Hakları",
      leave_requests: "İzin Talepleri",
      leave_approvals: "Bekleyen İzin Onayları"
    },
    hourly: "Saatlik İzin",
    daily: "Günlük İzin",
    type: "İzin Tipi",
    begin_time: "Başlangıç Saati",
    end_time: "Bitiş Saati",
    begin_date: "Başlangıç Tarihi",
    end_date: "Bitiş Tarihi",
    approved_time: "Onay Tarihi",
    request_time: "Talep Tarihi",
    approve_or_reject: "Onayla veya Reddet",
    status: "Durum",
    no_approver: "Onaylayan Yok",
    manager: "İzin Yöneticisi",
    managers: "İzin Yöneticileri",
    balance: "Bakiye",
    not_leave_accruals: "Bu çalışanın henüz bir izin haketmemiştir",
    permission: {
      employee_leave_approver_message: "Bu çalışan, diğer çalışanların izin taleplerini onaylayabilir",
      employee_not_leave_approver_message: "Bu çalışan, diğer çalışanların izin taleplerini onaylayamaz",
      employee_shift_approver_message: "Bu çalışan, diğer çalışanlara vardiya atayabilir",
      employee_not_shift_approver_message: "Bu çalışan, diğer çalışanlara vardiya atayamaz",
      employee_overtime_approver_message: "Bu çalışan, diğer çalışanların fazla mesai taleplerini onaylayabilir",
      employee_not_overtime_approver_message: "Bu çalışan, diğer çalışanların fazla mesai taleplerini onaylayamaz"
    },
    notification: {
      employee_receiver_leave_notification_message: "Bu çalışan, diğer çalışanların izin bildirimlerini alabilir",
      employee_not_receiver_leave_notification_message: "Bu çalışan, diğer çalışanların izin bildirimlerini alamaz",
      employee_receiver_shift_notification_message:
        "Bu çalışan, diğer çalışanların vardiya atama bildirimlerini alabilir",
      employee_not_receiver_shift_notification_message:
        "Bu çalışan, diğer çalışanların vardiya atama bildirimlerini alamaz",
      employee_receiver_overtime_notification_message:
        "Bu çalışan, diğer çalışanların fazla mesai talep bildirimlerini alabilir",
      employee_not_receiver_overtime_notification_message:
        "Bu çalışan, diğer çalışanların fazla mesai talep bildirimlerini alamaz"
    },
    respect: "Yukarıdaki izin yöneticileri öncelikli olacaktır",
    order_is_important: "Yöneticinin sırası önemlidir",
    already_selected_manager: "Bu yöneticiyi zaten seçtiniz",
    there_is_no_leave_manager: "Atanmış izin yöneticisi yok",
    add_leave_manager: "İzin Yöneticisi Ekle",
    used: "Kullanılan",
    remaining: "Kalan",
    on_leave: "İzinli",
    period: "Zaman Dilimi",
    duration: "Süre",
    periods: {
      first_half: "1.Yarım",
      second_half: "2.Yarım",
      first_quarter: "1.Çeyrek",
      second_quarter: "2.Çeyrek",
      third_quarter: "3.Çeyrek",
      fourth_quarter: "4.Çeyrek"
    },
    request: {
      this_day_does_not_count_as_leave: "Bugün {0}, izin günlerinden sayılmaz",
      leave_balance: "İzin Bakiyesi",
      max_exceed_leave_balance: "Avans Bakiyesi",
      leave_request_count: "Talep edilen",
      used: "Kullanılan",
      remaining: "Kalan",
      approved: "Onayla",
      denied: "Reddet",
      leave_decreased_count: "İzinden Düşülecek",
      requested_leave_type_documents: " İzin için getirilmesi gereken dokümanlar",
      required_document_message: " | Yüklemeniz gereken {count} döküman var | Yüklemeniz gereken {count} dökümanlar var"
    },
    accruals: {
      name: "İzin Adı",
      count: "Gün Sayısı",
      used: "Kullanılan Gün",
      previous_balance: "Önceki Bakiye"
    },
    approvals: {
      leave_approval: "İzin Onaylama",
      message:
        "<b>{0}</b> isimli çalışanın <b>{1}</b> - <b>{2}</b> tarihleri arasında toplam da <b>{3}</b> gün <b>{4}</b> isimli izni kullanmasını onaylamak istiyor musunuz?"
    },
    cancels: {
      leave_cancel: "İzin İptal",
      message: "İptal etme nedeniniz?",
      error_message: "İptal etme nedeniniz? alanı gereklidir"
    },
    error_messages: {
      notice_period_error: "Bu izin en az {0} gün önceden talep edilmelidir",
      max_consecutive_error: "Tek seferde maksimum {0} gün kadar izin talep edebilirsiniz",
      min_consecutive_error: "Tek seferde mininum {0} gün kadar izin talep edebilirsiniz",
      leave_request_exist_error: "Bu tarihlerde talep edilmiş bir izin bulunmaktadır",
      total_leave_balance_error1: "Bu izin için yeterli bakiyeniz bulunmamaktadır",
      total_leave_balance_error2:
        "Bu izin için maximum {0} gün avans bakiyeden kullanabilirsiniz, avans bakiyeniz yetmediği için izin talebinde bulunamazsınız",
      leave_balance_error1: "Bakiyeniz yetmediği için",
      leave_balance_error2: "gün avans bakiyenizden düşülecektir"
    },
    e_signature: "E-imza",
    e_signature_leave_form: "E-imzalı İzin Formu",
    leave_form: "İzin Formu",
    leave_cancel: "İzin İptal",
    signed: "İmzalandı",
    not_signed: "İmzalanmadı",
    leave_form_name: "izin_formu_"
  },
  leave_request_status: {
    pending: "Onay Bekleyen",
    PENDING: "Onay Bekleyen",
    approved: "Onaylandı",
    APPROVED: "Onaylandı",
    denied: "Reddedildi",
    DENIED: "Reddedildi",
    rejected: "Reddedildi",
    REJECTED: "Reddedildi",
    cancelled: "İptal Edildi",
    CANCELLED: "İptal Edildi",
    need_extra_detail: "Ekstra detay isteniyor",
    NEED_EXTRA_DETAIL: "Ekstra detay isteniyor",
    null: "Bilinmiyor",
    NULL: "Bilinmiyor",
    undefined: "Bilinmiyor",
    UNDEFINED: "Bilinmiyor",
    closed: "Kapalı",
    CLOSED: "Kapalı"
  },
  time_duration: {
    hour: "Saat",
    minute: "Dakika",
    second: "Saniye"
  },
  leave_type: {
    paid: "Ücretli",
    unpaid: "Ücretsiz",
    on_duty: "Görevli",
    restricted_holiday: "Kısıtlı Tatil"
  },
  leave_status: {
    APPROVED: "Onaylandı",
    PENDING: "Beklemede",
    DENIED: "Reddedildi",
    CANCELLED: "İptal Edildi",
    NEED_EXTRA_DETAIL: "Detay gerekli",
    not_come: "Sırası gelmedi",
    NOT_COME: "Sırası gelmedi"
  },
  leave_duration: {
    FULL_DAY: "Tam gün {0}",
    HALF_DAY: "Yarım gün {0}",
    QUARTER_DAY: "Çeyrek gün {0}",
    HOURLY_DAY: "Çeyrek gün {0}",
    HOURLY: "Saatlik {0}"
  },
  documentVisibleByHR:
    "Bu belgenin ilgili İnsan Kaynakları ekipleri ve yöneticim tarafından görüntülenebileceğini onaylıyorum"
};
